/**
 * Package Storage Types
 *
 * Types for managing resource packages (virtual groupings)
 */
// ============================================================================
// UTILITIES
// ============================================================================
/**
 * Convert package resource to key string
 */
export function packageResourceToKey(resource) {
    return `${resource.server}/${resource.owner}/${resource.language}/${resource.resourceId}`;
}
/**
 * Parse key string to package resource parts
 */
export function parsePackageResourceKey(key) {
    const parts = key.split('/');
    if (parts.length !== 4)
        return null;
    return {
        server: parts[0],
        owner: parts[1],
        language: parts[2],
        resourceId: parts[3],
    };
}
